const PERMISSION_MODES = [
  {
    key: 'global',
    label: 'Global Permissions',
    items: [
      {
        key: 'global.see_all_jobs',
        label: 'See all jobs (all sites)',
      },
    ],
  },
  {
    key: 'admin',
    label: 'Admin Mode',
    sections: [
      {
        title: 'Site Permissions',
        items: [
          {
            key: 'admin.site.edit_primary',
            label: 'Edit primary site information',
          },
          {
            key: 'admin.site.edit_all',
            label: 'Edit all sites information',
          },
          { key: 'admin.site.create', label: 'Create sites' },
          {
            key: 'admin.site.manage_phases',
            label: 'Manage site job phases',
          },
        ],
      },
      {
        title: 'User Approvals & Roles',
        items: [
          {
            key: 'admin.approvals.approve_edit_primary',
            label: 'Manage primary site users',
          },
          {
            key: 'admin.approvals.approve_edit_all',
            label: 'Manage all site users',
          },
        ],
      },
      {
        title: 'Instrumentation',
        items: [
          {
            key: 'admin.instrumentation.edit_primary',
            label: 'Edit primary site instrumentation',
          },
          {
            key: 'admin.instrumentation.edit_all',
            label: 'Edit all sites instrumentation',
          },
          {
            key: 'admin.instrumentation.create_edit_types',
            label: 'Create/edit instrument types',
          },
        ],
      },
    ],
  },
  {
    key: 'editor',
    label: 'Editor Mode',
    items: [
      { key: 'editor.create_templates', label: 'Create templates' },
      { key: 'editor.edit_all_template', label: 'Edit all templates' },
    ],
  },
  {
    key: 'publisher',
    label: 'Publisher Mode',
    items: [
      { key: 'publisher.create_jobs', label: 'Create jobs' },
      {
        key: 'publisher.edit_visible_jobs',
        label: 'Edit all visible jobs',
      },
    ],
  },
  {
    key: 'inspector',
    label: 'Inspector Mode',
    items: [
      { key: 'inspector.leadman_signoff', label: 'Leadman sign off' },
      {
        key: 'inspector.edit_visible_jobs',
        label: 'Edit all visible jobs',
      },
    ],
  },
  {
    key: 'report',
    label: 'Report Mode',
    items: [
      { key: 'report.engineering_review', label: 'Engineering review' },
      { key: 'report.download', label: 'Download report' },
      { key: 'report.edit_visible_jobs', label: 'Edit all visible jobs' },
    ],
  },
];

const flattenModeItems = (mode) => {
  if (Array.isArray(mode.items)) {
    return mode.items;
  }

  if (Array.isArray(mode.sections)) {
    return mode.sections.flatMap((section) => section.items || []);
  }

  return [];
};

export const buildPermissionSelections = (defaultValue = false) => {
  return PERMISSION_MODES.reduce((acc, mode) => {
    flattenModeItems(mode).forEach((item) => {
      acc[item.key] = defaultValue;
    });
    return acc;
  }, {});
};

export const addPermissionMode = (newMode) => {
  if (!newMode || !newMode.key) return;
  if (PERMISSION_MODES.some((mode) => mode.key === newMode.key)) return;
  PERMISSION_MODES.push(newMode);
};

export default PERMISSION_MODES;
